// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poppins:400,700,900);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: grey !important;
}

* {
  font-family: Work Sans;
}
code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

.labelHeading {
  font-size: 18px;
  font-weight: 500;
  margin-right: 4px;
}

/* index.css or global CSS file */
::-webkit-scrollbar {
  width: 8px; /* Adjust the scrollbar width */
  height: 8px; /* For horizontal scrollbars */
}

::-webkit-scrollbar-track {
  background: #f1f1f1; /* Background of the scrollbar track */
}

::-webkit-scrollbar-thumb {
  background-color: #888; /* Scrollbar color */
  border-radius: 8px; /* Rounded scrollbar edges */
  border: 2px solid #f1f1f1; /* Adds padding around the thumb */
}

::-webkit-scrollbar-thumb:hover {
  background-color: #555; /* Color when hovering over the scrollbar */
}

/* Firefox scrollbar styling */
* {
  scrollbar-width: thin; /* Makes scrollbar width thinner */
  scrollbar-color: #888 #f1f1f1; /* Thumb color and track color */
} /* Hide sidebar on small screens */
/* Base sidebar styles for larger screens */

/* Mobile-specific styles */

/* Base sidebar styles for larger screens */

/* Mobile-specific styles */
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE;aACW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,iCAAiC;AACjC;EACE,UAAU,EAAE,+BAA+B;EAC3C,WAAW,EAAE,8BAA8B;AAC7C;;AAEA;EACE,mBAAmB,EAAE,sCAAsC;AAC7D;;AAEA;EACE,sBAAsB,EAAE,oBAAoB;EAC5C,kBAAkB,EAAE,4BAA4B;EAChD,yBAAyB,EAAE,kCAAkC;AAC/D;;AAEA;EACE,sBAAsB,EAAE,2CAA2C;AACrE;;AAEA,8BAA8B;AAC9B;EACE,qBAAqB,EAAE,kCAAkC;EACzD,6BAA6B,EAAE,gCAAgC;AACjE,EAAE,kCAAkC;AACpC,2CAA2C;;AAE3C,2BAA2B;;AAE3B,2CAA2C;;AAE3C,2BAA2B","sourcesContent":["@import url(\"https://fonts.googleapis.com/css?family=Poppins:400,700,900\");\n@import url(\"https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,100..900;1,100..900&display=swap\");\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: grey !important;\n}\n\n* {\n  font-family: Work Sans;\n}\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\n.labelHeading {\n  font-size: 18px;\n  font-weight: 500;\n  margin-right: 4px;\n}\n\n/* index.css or global CSS file */\n::-webkit-scrollbar {\n  width: 8px; /* Adjust the scrollbar width */\n  height: 8px; /* For horizontal scrollbars */\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1; /* Background of the scrollbar track */\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: #888; /* Scrollbar color */\n  border-radius: 8px; /* Rounded scrollbar edges */\n  border: 2px solid #f1f1f1; /* Adds padding around the thumb */\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background-color: #555; /* Color when hovering over the scrollbar */\n}\n\n/* Firefox scrollbar styling */\n* {\n  scrollbar-width: thin; /* Makes scrollbar width thinner */\n  scrollbar-color: #888 #f1f1f1; /* Thumb color and track color */\n} /* Hide sidebar on small screens */\n/* Base sidebar styles for larger screens */\n\n/* Mobile-specific styles */\n\n/* Base sidebar styles for larger screens */\n\n/* Mobile-specific styles */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
